import { request } from '@/utils/ajax';
import { createQueryHook } from '@/utils/hooks';
import type {
    OptionPresetCreateOptions,
    OptionPresetDto,
    OptionPresetEditOptions,
    ReorderPresetsRequest,
} from './option-preset.types';

export function getOptionPresets(optionPresetGroupId: number): Promise<OptionPresetDto[]> {
    return request(`api/option-preset-group/${optionPresetGroupId}/presets`, {}).then((x) => x.json());
}

export function createOptionPreset(options: OptionPresetCreateOptions): Promise<OptionPresetDto> {
    return request('api/option-preset', {
        method: 'POST',
        json: true,
        body: options,
    }).then((x) => x.json());
}

export function updateOptionPreset(options: OptionPresetEditOptions): Promise<OptionPresetDto> {
    return request(`api/option-preset/${options.id}`, {
        method: 'PUT',
        json: true,
        body: options,
    }).then((x) => x.json());
}

export function deleteOptionPreset(presetId: number): Promise<any> {
    return request(`api/option-preset/${presetId}`, {
        method: 'DELETE',
    });
}

export function reorderOptionPresets(requestPayload: ReorderPresetsRequest): Promise<any> {
    return request('api/option-preset/sort-order', {
        method: 'PUT',
        json: true,
        body: {
            BuyerOptionPresetGroupId: requestPayload.buyerOptionPresetGroupId,
            SortedPresetIds: requestPayload.sortedPresetIds,
        },
    });
}
